import Cookies from "js-cookie";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";

import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { convertUTCtoIST } from "@/utils";
import { fetchAllPerformanceLogsOfEmployeeForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { PerformanceLog } from "./_components/todos-table/schema";
import { getColumns } from "./_components/todos-table/columns";
import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { DataTable } from "./_components/todos-table/data-table";

const PerformanceLogsPageForEmployee = () => {
  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  // const startdate = dateRange?.from as Date;
  const startdate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.from as Date).setHours(0)).setMinutes(0)
    )
  );
  const enddate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.to as Date).setHours(23)).setMinutes(59)
    )
  );

  const { data, isPending, isFetching } = useQuery(
    fetchAllPerformanceLogsOfEmployeeForEmployeeQueryOptions(key, {
      startdate,
      enddate,
    })
  );

  const logsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.log === undefined) {
      return [];
    }

    const result = data?.log?.map((t) => {
      return {
        id: t?._id,
        deduction: t?.deduction,
        reasonPositive: t?.reasonPositive,
        reasonNegative: t?.reasonNegative,
        createdAt: t?.createdAt,
        date: t?.date,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<PerformanceLog, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Performance Logs</h3>

        <div className="flex items-center gap-2">
          <DateRangePicker />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        <DataTable data={logsData} columns={columns} />
      </div>
    </div>
  );
};

export default PerformanceLogsPageForEmployee;
